module.exports = __webpack_public_path__ + "static/media/Airwave-Regular.2a1a7829.ttf";